// @flow

import { DomainList as ListNDS } from '../componentsNDS/DomainList';
import { RenewCommercialBlock } from '../componentsNDS/RenewCommercialBlock';
import { SuggestedProducts } from '../componentsNDS/SuggestedProducts';

export function NDSSwitch(): React.MixedElement | null {
  return (
    <>
      <ListNDS />
      <SuggestedProducts />
      <RenewCommercialBlock />
    </>
  );
}
